module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b35d2b90f81b498c4d9ef92b53ad8a82.png";